import React from 'react';
import { Routes } from 'react-router-dom';

import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Feature } from '@occc/utils-access-control';
import { SentryRoute as Route } from '@occc-app/App/sentry';

import PunchcardConfigurePage from './PunchcardConfigurePage';
import PunchcardCreatePage from './PunchcardCreatePage';
import PunchcardUpdatePage from './PunchcardUpdatePage';

const Punchcard: React.FC = () => (
  <Routes>
    <Route
      path='create'
      element={
        <ProtectedRoute feature={Feature.CAMPAIGN_COMPONENT_CREATE}>
          <PunchcardCreatePage />
        </ProtectedRoute>
      }
    />
    <Route path=':punchcardId/configure/*' element={<PunchcardConfigurePage />} />
    <Route path=':punchcardId/update/*' element={<PunchcardUpdatePage />} />
  </Routes>
);

export default Punchcard;
